import { render, staticRenderFns } from "./ResourceCategories.vue?vue&type=template&id=33a73173"
import script from "./ResourceCategories.vue?vue&type=script&lang=js"
export * from "./ResourceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports